export default __webpack_public_path__ + "static/media/LogoINTEL.e7129aee.png";